const FAVORITES_KEY = 'sanzberger_favorites';
const FAVORITES_EVENT = 'sanzberger-favorites-changed';

export const getFavorites = () => {
  try {
    return JSON.parse(localStorage.getItem(FAVORITES_KEY)) || [];
  } catch {
    return [];
  }
};

export const isFavorite = (id) => getFavorites().includes(id);

export const toggleFavorite = (id) => {
  const favorites = getFavorites();
  const index = favorites.indexOf(id);

  if (index === -1) {
    favorites.push(id);
  } else {
    favorites.splice(index, 1);
  }

  localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
  window.dispatchEvent(new Event(FAVORITES_EVENT));

  return favorites.includes(id);
};

export const onFavoritesChanged = (callback) => {
  window.addEventListener(FAVORITES_EVENT, callback);
  return () => window.removeEventListener(FAVORITES_EVENT, callback);
};
